import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import TooltipBubble from './TooltipBubble';

/**
 * Small info icon that reveals a help bubble on hover or keyboard focus.
 * Admin-themed wrapper over the shared TooltipBubble shell. Use next to a form
 * field label/description to tuck reference detail behind progressive disclosure.
 *
 * @param {string} content - Help text shown in the bubble and the button's aria-label.
 * @param {string} [label] - Accessible prefix for the aria-label (e.g. field name).
 * @param {string} [className] - Extra classes on the wrapper for placement.
 */
const InfoTooltip = ({ content, label, className = '' }) => (
  <TooltipBubble
    className={className}
    content={content}
    ariaLabel={label ? `${label}: ${content}` : content}
    trigger={<InformationCircleIcon className="w-4 h-4" aria-hidden="true" />}
    buttonClassName="inline-flex items-center justify-center text-ink-400 hover:text-ink-600
      focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-accent-500
      rounded-full transition-colors cursor-help"
    bubbleClassName="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 z-10
      w-max max-w-[240px] px-2.5 py-1.5 rounded text-xs leading-snug shadow-lift
      bg-ink-800 text-white opacity-0 group-hover:opacity-100 group-focus-within:opacity-100
      transition-opacity duration-150"
    arrowClassName="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-ink-800"
  />
);

export default InfoTooltip;
